import { Link } from 'react-router-dom'
import Logo from '../Logo'
import LienAccueil from './LienAccueil'
import AnchorLink from './AnchorLink'
import { useAuth } from '../AuthContext'
import { NOM_PRODUIT } from '../constants'

export default function SiteHeader() {
  const { user, isAuthenticated, isAdmin, logout } = useAuth()

  return (
    <header className="border-b border-brand-100 sticky top-0 bg-white/95 backdrop-blur z-40">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 min-h-16 py-2 flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
        <LienAccueil aria-label={`Accueil ${NOM_PRODUIT}`}><Logo /></LienAccueil>
        {/* aria-label (RGAA 12.6) + py-2.5 (audit 07/09) : les trois liens faisaient 20 px de
            haut, sous le minimum WCAG 2.5.8 de 24 px — 40 px désormais, dans une barre de 64. */}
        <nav className="hidden md:flex items-center gap-6 text-sm text-brand-600" aria-label="Navigation principale">
          <AnchorLink to="/#recherche" className="inline-flex items-center py-2.5 hover:text-brand-900 transition">L'Observatoire</AnchorLink>
          <AnchorLink to="/#tarifs" className="inline-flex items-center py-2.5 hover:text-brand-900 transition">Tarifs</AnchorLink>
          <Link to="/collectivites" className="inline-flex items-center py-2.5 hover:text-brand-900 transition">Collectivités</Link>
        </nav>
        <div className="flex items-center gap-2">
          {isAuthenticated ? (
            <>
              <AnchorLink to={isAdmin ? '/admin' : user?.commune_reference ? `/o/${user.commune_reference}/synthese` : '/#recherche'}
                className="text-sm font-medium border border-brand-200 rounded-lg px-4 py-2 hover:bg-brand-50 transition">
                Mon espace
              </AnchorLink>
              <button onClick={logout}
                className="text-sm font-medium text-brand-600 hover:text-brand-900 px-3 py-2 transition">
                Se déconnecter
              </button>
            </>
          ) : (
            <Link to="/login"
              className="text-sm font-medium text-brand-600 hover:text-brand-900 px-3 py-2 transition">
              Se connecter
            </Link>
          )}
          {/* P0-11 : un compte rattaché atterrit sur SA commune, pas sur la recherche. */}
          <AnchorLink to={isAuthenticated && user?.commune_reference ? `/o/${user.commune_reference}/synthese` : '/#recherche'}
            className="text-sm font-semibold bg-brand-900 text-white rounded-lg px-4 py-2 hover:bg-brand-800 transition">
            Voir ma commune
          </AnchorLink>
        </div>
      </div>
    </header>
  )
}
